module.exports = __webpack_public_path__ + "static/media/logo-super.35694d64.svg";